// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__qAks-","icon":"Avatar_icon__-Bg6T","floatIcon":"Avatar_floatIcon__HqxDb","avatar":"Avatar_avatar__Hot40"};